// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3C9oi","visuallyhidden":"_2_1og","hide-text":"_1apAh","center":"d2rPS","noprint":"wkdCP","root":"_3Bu0o"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/cn-skin-core/styles/svg/Chevron.scss
 ** module id = 194
 ** module chunks = 0
 **/